/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".control-group{margin:5px 10px}.field{width:80%;display:inline-block}.control-label{margin-top:4px;font-weight:700}.recipientList i{padding:2px 5px}.recipientList table{display:-webkit-box;display:flex}.recipientList tr:hover{background-color:#efefef}.recipientList td{padding:3px}"];
export { styles as styles };
